import { ReactElement, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import { fetchPartners } from 'pages/NewNonEmployee/_api';
import StaticAutoComplete from '../base/StaticAutoComplete';
import { sortByGroup, sortByLabel } from 'pages/NewNonEmployee/_util';

/**
 * Prompt user for input: partner type
 * @param {any} props properties to be passed to the autocomplete
 * @returns {ReactElement} autocomplete prompting for partner type
 */
const PartnerType = props => {
	const [originalOptions, setOriginalOptions] = useState([]);
	const [sLoading, setLoading] = useState(true);

	useEffect(() => {
		let active = true;
		async function fetchApi() {
			const response = await fetchPartners();
			const processedResponse = response
				.map(u => ({
					value: u.name,
					label: u.name,
					group: null,
				}))
				.sort(sortByLabel)
				.sort(sortByGroup);
			setOriginalOptions(processedResponse);
			setLoading(false);
		}
		if (active) {
			fetchApi();
		}

		return () => {
			active = false;
		};
	}, []);

	return sLoading ? (
		<Skeleton width='100%' />
	) : (
		<StaticAutoComplete originalOptions={originalOptions} {...props} />
	);
};

PartnerType.propTypes = {
	label: PropTypes.string.isRequired,
	helperText: PropTypes.string,
	name: PropTypes.string.isRequired,
};

export default PartnerType;
